<template>
  <div class="row">
    <div class="col-lg-12">
      <loader v-if="!isLoaded"></loader>

      <div class="row without_btn">
        <div class="col-12">
          <table-view
              :options="options"
              :isLoaded=isLoaded
              :isChange=isChange
              :isList=isMobile>

            <div slot="action" slot-scope="props">
              <mdc-icon class="mr-2 text-warning" icon="mail" v-if="props.row.hasUnreadComments"></mdc-icon>
              <router-link :to="{ name: 'subscription', params: { id: props.row.id }}">
                <mdc-icon icon="edit"></mdc-icon>
              </router-link>
            </div>
          </table-view>
        </div>
      </div>

      <form novalidate class="mt-4">
        <h4 class="row-title">{{'subscription.title' | trans}}</h4>


        <div class="form-group row mt-2">
          <div class="col-12 col-lg-4">
            <div class="datepicker datepicker__width">
            <span class="datepicker__label">
                 {{'subscription.start_date' | trans }}
            </span>

              <v-date-picker
                  v-model='rangeDateStart'
                  :formats='formats'
                  title-position="left"
                  :input-props='{ readonly: true }'
                  :min-date='new Date()'>
              </v-date-picker>

              <mdc-icon icon="date_range"></mdc-icon>
            </div>
          </div>

          <div class="col-12 col-lg-4 mt-2 mt-md-0">
            <div class="datepicker datepicker__width">
            <span class="datepicker__label">
                 {{'subscription.end_date' | trans }}
            </span>

              <v-date-picker
                  v-model='rangeDateEnd'
                  :formats='formats'
                  title-position="left"
                  :input-props='{ readonly: true }'
                  :min-date='rangeDateStart'>
              </v-date-picker>

              <mdc-icon icon="date_range"></mdc-icon>
            </div>
          </div>

          <div class="col-12 col-lg-4 mt-4 mt-md-0">
            <mdc-textfield id="client_count"
                           :label="'profile.client_count' | trans"
                           type="text"
                           name="client_count"
                           class="mt-0"
                           :class="{'is-invalid': errors.has('client_count')}"
                           v-validate="'required|numeric|min_value:1'"
                           v-model="client_count"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.client_count' | trans"/>

            <span class="invalid-feedback"
                  v-if="errors.has('client_count')">
                                <strong>{{ errors.first('client_count') }}</strong>
                            </span>
          </div>

          <div class="col-12">
            <mdc-textfield id="comment"
                           ref="comment"
                           :label="'subscription.add_comment' | trans"
                           type="text"
                           multiline
                           rows="2"
                           name="comment"
                           v-model="comment"
                           data-vv-validate-on="none"
                           :data-vv-as="'validation.attributes.comment' | trans"/>
            <span class="invalid-feedback" v-if="errors.has('comment')">
                                    <strong>{{ errors.first('comment') }}</strong>
                                </span>
          </div>


        </div>

        <div class="form-group row">
          <div class="col-md-12 text-right">

            <button type="submit"
                    class="btn btn-primary btn-sm"
                    @click.prevent="sendRequest">
              {{'protocol.buttons.sendRequest' | trans}}
            </button>
          </div>
        </div>

      </form>

    </div>


  </div>
</template>

<script>

    import TableView from '../../../common/table/components/TableView';
    import lang from '../../../lang/translator';
    import {mapGetters} from 'vuex';
    import axios from 'axios';
    import Manager from '../api/Manager';
    import moment from 'moment';
    import Constants from '../../undesirableBehavior/Constants';
    import Loader from '../../loader/components/Loader';
    import {Validator} from 'vee-validate';

    export default {
    name: 'Profile',
    data() {
      return {
        client: {},
        isChange: false,
        disabled: false,
        onlyList: false,
        reloadBids: false,
        isLoaded: true,
        rangeDateStart: this.getDateStart(new Date()),
        rangeDateEnd: new Date(),
        price: "999 рублей",
        client_count: null,
        minDateStart: this.getMinDateStart(new Date()),
        regions: [],
        regionId: null,
        loading: false,
        lastId: null,
        isLastPage: false,
        comment: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        options: {
          filterable: false,
          debounce: 1000,
          sortable: [],
          skin: 'table table-sm',
          columns: [
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('subscription.start_date'),
            },
            {
              key: 'finishedAt',
              changed: false,
              headings: lang.get('subscription.end_date'),
            },
            {
              key: 'clientCount',
              changed: false,
              headings: lang.get('profile.client_count'),
            },
            {
              key: 'cost',
              changed: false,
              headings: lang.get('profile.price'),
            },
            {
              key: 'status',
              changed: false,
              headings: lang.get('profile.status'),
            },
            {
              key: 'action',
              changed: true,
              headings: '',
            },
          ],
          listRow: {
            startedAt:{
              headings: lang.get('subscription.start_date'),
              hasTemplate: false,
            },
            finishedAt:{
              headings: lang.get('subscription.end_date'),
              hasTemplate: false,
            },
            clientCount:{
              headings: lang.get('profile.client_count'),
              hasTemplate: false,
            },
            cost:{
              headings: lang.get('profile.price'),
              hasTemplate: false,
            },
            status:{
              headings: lang.get('profile.status'),
              hasTemplate: false,
            },
          },
          templates: {
            startedAt: this.startDateFormat,
            finishedAt: this.finishedDateFormat,
          },
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total,
            };
          },
          texts: {
            filter: '',
            filterPlaceholder: lang.get(
                'user.type_the_therapist_name_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          columnsClasses: {
            clientCount: 'text-center',
            cost: 'text-center',
            action: 'text-right actions-cell',
          },
          perPage: 10,
        },
      };
    },
    components: {
      TableView, Loader
    },

    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },

    methods: {

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      startDateFormat(h, row) {
        return this.toLocaleDate(row.startedAt.date);
      },

      finishedDateFormat(h, row) {
        return this.toLocaleDate(row.finishedAt.date);
      },

      nextPage: async function () {
        if (!this.isLastPage) {
          this.loading = true;
          let response = await axios.get(this.apiUrl, {
            params: {
              perPage: this.perPage,
              page: this.page,
            },
          });

          response.data.data.items.forEach((item) => {
            this.therapists.push(item)
          });

          this.loading = false;
          this.lastId = this.therapists[this.therapists.length - 1].id;
          if (response.data.data.lastPage != this.page) {
            this.page++;
          } else {
            this.isLastPage = true;
          }
        }
      },

      onSetSelected: function (selected) {
        this.therapistId = selected;
      },

      getOptionTitle: function ({option}) {
        return option.name;
      },
      isLast: function ({option}) {
        return option.id == this.lastId;
      },

      async requestFunction(data) {
        let response = await Manager.getSubscriptions(data.limit, data.page);
        return response;
      },

      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
            date.getDate());
        return minDateStart;
      },

      getDateStart: function (date) {
        let minDateStart = new Date(date.getFullYear(), date.getMonth(),  date.getDate(), (date.getHours() - 1));
        return minDateStart;
      },

      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).startOf('day').unix() + (Math.abs(this.rangeDateStart.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).endOf("day").unix() + (Math.abs(this.rangeDateEnd.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },

      sendRequest: async function () {
        this.errors.clear();
        let result = await this.$validator.validateAll();
        if (result) {
          try {
            this.isLoaded = false;
            let response = await Manager.setSubscription({
              "startedAt": this.rangeDateStartTimestamp(),
              "finishedAt": this.rangeDateEndTimestamp(),
              "clientCount": this.client_count,
              "comment": this.comment,
            });

          } catch (e) {
            console.error('Unknown API error occurred.');
          } finally {
            this.isChange = true;
            this.isLoaded = true;
            this.comment = null;
            this.rangeDateStart = this.getDateStart(new Date());
            this.rangeDateEnd = new Date();
            this.client_count = null;
          }

        }
      }
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/Subscriptions.vue